<template>
  <section id="sponsor">
    <div class="px-4 py-4 text-center">
      <h3 class="txtSponsor"> Siamo l'unica azienda italiana tra i membri di </h3>
      <div class="apra">
        <img src="https://www.rimborsoalvolo.it/cresources/outform/images/LogoApra.svg">
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "SezioneAPRA"
}
</script>

<style scoped>

</style>